import { PickupKind, POOL_CAPACITY } from '../constants';
import { IndexPool } from './IndexPool';

export class PickupPool {
  readonly indices = new IndexPool(POOL_CAPACITY.pickups);
  readonly x = new Float32Array(POOL_CAPACITY.pickups);
  readonly y = new Float32Array(POOL_CAPACITY.pickups);
  readonly vx = new Float32Array(POOL_CAPACITY.pickups);
  readonly vy = new Float32Array(POOL_CAPACITY.pickups);
  readonly life = new Float32Array(POOL_CAPACITY.pickups);
  readonly value = new Uint16Array(POOL_CAPACITY.pickups);
  readonly kind = new Uint8Array(POOL_CAPACITY.pickups);
  overflowDrops = 0;

  spawn(kind: PickupKind, x: number, y: number, value: number, vx = -0.45, vy = 0): number {
    const index = this.indices.acquire();
    if (index < 0) {
      this.overflowDrops += 1;
      return -1;
    }
    this.kind[index] = kind;
    this.x[index] = x;
    this.y[index] = y;
    this.vx[index] = vx;
    this.vy[index] = vy;
    this.value[index] = value;
    this.life[index] = 900;
    return index;
  }

  update(): void {
    // HOTPATH-BEGIN
    const active = this.indices.active;
    for (let i = 0; i < active.length; i += 1) {
      if (active[i] === 0) continue;
      this.x[i] += this.vx[i];
      this.y[i] += this.vy[i];
      this.vy[i] *= 0.985;
      this.life[i] -= 1;
      if (this.life[i] <= 0 || this.x[i] < -20) this.indices.release(i);
    }
    // HOTPATH-END
  }

  reset(): void {
    this.indices.reset();
    this.overflowDrops = 0;
  }
}
